import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Stack,
} from '@mui/material';
import { BackNavigationAppBar } from '@marageti/z4-lib';
import { MatchingProvider } from '../../store/contexts/matching';
import MatchingFABFooter from '../../components/trip-request-matching/layout/footer';
import InfoPanel from '../../components/trip-request-matching/layout/info-panel';
import SelectedMatchCards from '../../components/trip-request-matching/layout/selected-matches';

const MatchingLayout = () => (
  <MatchingProvider>
    <BackNavigationAppBar
      primary="Match"
      defaultPath=".."
    />
    <Container
      maxWidth="xl"
      sx={{
        display: 'flex',
        flex: 1,
      }}
    >
      <Grid
        container
        spacing={{ mobile: 3, desktop: 6 }}
      >
        <Grid
          item
          mobile={12}
          desktop={4}
        >
          <Stack
            spacing={2}
            sx={(theme) => ({
              paddingRight: 2,
              paddingBottom: 3,
              [theme.breakpoints.up('desktop')]: {
                overflowY: 'auto',
                overscrollBehavior: 'contain',
                height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - ${theme.mixins.toolbar.minHeight}px - 6px)`,
              },
            })}
          >
            <SelectedMatchCards />
            <InfoPanel />
          </Stack>
        </Grid>
        <Grid
          item
          mobile={12}
          desktop={8}
          sx={{
            marginBottom: '78px',
          }}
        >
          <Box
            sx={(theme) => ({
              paddingRight: 2,
              paddingBottom: 3,
              [theme.breakpoints.up('desktop')]: {
                overflowY: 'auto',
                overscrollBehavior: 'contain',
                height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px - ${theme.mixins.toolbar.minHeight}px - 6px)`,

              },
            })}
          >
            <Outlet />
          </Box>
        </Grid>
      </Grid>
    </Container>
    <MatchingFABFooter />
  </MatchingProvider>
);

export default MatchingLayout;
